import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";

import {
  NavController,
  AlertController,
  LoadingController,
  ToastController,
  MenuController,
} from "@ionic/angular";

import { AccountService } from "../../../api/account.service";
import { __core_private_testing_placeholder__ } from "@angular/core/testing";
import { AppSettings } from "src/app/app-settings";

import { IonicSelectableComponent } from "ionic-selectable";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.page.html",
  styleUrls: ["./profile.page.scss"],
})
export class ProfilePage implements OnInit {
  public profileForm: FormGroup;
  public countries: [];
  public currentProfile: {};
  public isManager: boolean;
  public wrongCountry: string;
  public hasOtherEmail: boolean = false;
  isWeb = AppSettings.IS_WEB;

  constructor(
    private accountService: AccountService,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private menuCtrl: MenuController
  ) { }

  ngOnInit() {
    this.profileForm = this.formBuilder.group({
      firstName: [null, Validators.compose([Validators.maxLength(30)])],
      lastName: [null, Validators.compose([Validators.maxLength(30)])],
      email: [null, Validators.compose([])],
      matchingReceptionEmail: [null, null],
      otherMatchingReceptionEmail: [null, null],
      phone: [null, Validators.compose([Validators.maxLength(50)])],
      country: [
        null,
        Validators.compose([Validators.maxLength(50), Validators.required]),
      ],
      region: [null, null],
      useMatchingReceptionEmail: [false, null],
      receiveMatchingReports: [null, null],
      self_copy: false,
      receive_ot_emails: false,
      signature: [null, Validators.compose([Validators.maxLength(200)])],
    });
    this.setDynamicValidators();

    const shouldNavigateBack = localStorage.getItem('shouldNavigateBack');
    if (shouldNavigateBack) {
      localStorage.removeItem('shouldNavigateBack');
      this.navCtrl.navigateBack("/tabs/tab1");
    }

  }

  async ionViewWillEnter() {
    this.markFormGroupUnTouched(this.profileForm);

    let t = this;
    let loader = await this.loadingCtrl.create({
      message: "Loading...",
    });

    loader.present();

    this.accountService
      .myProfile()
      .then((response) => {
        t.countries = response["countries"];
        delete response["countries"];
        t.currentProfile = response;
        t.isManager = response["is_manager"];
        t.loadData();
        loader.dismiss();
      })
      .catch(() => {
        t.loadingCtrl.dismiss();
      });
  }

  loadData() {
    this.profileForm.patchValue({
      firstName: this.currentProfile["first_name"],
      lastName: this.currentProfile["last_name"],
      email: this.currentProfile["email"],
      phone: this.currentProfile["phone"],
      country: {
        code: this.currentProfile["country"],
        name: this.currentProfile["country_name"],
      },
      region: this.currentProfile["region"],
      receiveMatchingReports: this.currentProfile["receive_matching_reports"],
      signature: this.currentProfile["signature"],
      matchingReceptionEmail: this.currentProfile["matching_reception_email"],
      otherMatchingReceptionEmail:
        this.currentProfile["matching_reception_email_second"],
      useMatchingReceptionEmail:
        this.currentProfile["use_matching_reception_email"],
      self_copy: this.currentProfile["self_copy"],
      receive_ot_emails: this.currentProfile["receive_ot_emails"]
    });
  }

  cancel() {
    this.loadData();
    this.toastCtrl.dismiss().catch(() => {
      //Do nothing, only occurs when there is no toast present
    });
  }

  async saveProfile() {
    //Touch all fields to display hidden error messages.
    //Returns if the form is invalid.
    this.markFormGroupTouched(this.profileForm);

    if (!this.profileForm.valid) {
      return;
    }

    let loader = await this.loadingCtrl.create({
      message: "Saving...",
    });

    loader.present();

    let t = this;
    let profile = {
      first_name: !!t.profileForm.get("firstName").value
        ? t.profileForm.get("firstName").value
        : "",
      last_name: !!t.profileForm.get("lastName").value
        ? t.profileForm.get("lastName").value
        : "",
      email: t.currentProfile["email"],
      phone: !!t.profileForm.get("phone").value
        ? t.profileForm.get("phone").value
        : "",
      country: !!t.profileForm.get("country").value
        ? t.profileForm.get("country").value
        : "",
      receive_matching_reports: t.profileForm.get("receiveMatchingReports")
        .value,
      signature: !!t.profileForm.get("signature").value
        ? t.profileForm.get("signature").value
        : "",
      use_matching_reception_email: !!t.profileForm.get(
        "useMatchingReceptionEmail"
      ).value
        ? t.profileForm.get("useMatchingReceptionEmail").value
        : false,
      self_copy: t.profileForm.get("self_copy").value,
      receive_ot_emails: t.profileForm.get("receive_ot_emails").value

    };
    if (t.profileForm.get("useMatchingReceptionEmail").value) {
      profile["matching_reception_email"] = !!t.profileForm.get(
        "matchingReceptionEmail"
      ).value
        ? t.profileForm.get("matchingReceptionEmail").value
        : "";

      profile["matching_reception_email_second"] = !!t.profileForm.get(
        "otherMatchingReceptionEmail"
      ).value
        ? t.profileForm.get("otherMatchingReceptionEmail").value
        : "";
    }

    this.accountService
      .myProfile(profile, true)
      .then(async (response) => {
        t.currentProfile = response;
        t.loadData();
        loader.dismiss();

        t.toastCtrl.dismiss().catch(() => {
          //Do nothing, only occurs when there is no toast present
        });

        const toast = await t.toastCtrl.create({
          message: "Profile successfully updated",
          duration: 1000,
          showCloseButton: true,
          position: "bottom",
          color: "light",
        });
        toast.present().then(() => {
          this.goToAllPosts();
        });
      })
      .catch(async (errorResponse) => {
        let error = errorResponse.error;
        let errorMsg = "";

        Object.keys(error).forEach((key) => {
          errorMsg += key + " : ";

          error[key].forEach((errorCause, index) => {
            errorMsg += index > 0 ? ". " + errorCause : errorCause;
          });
        });

        t.toastCtrl.dismiss().catch(() => {
          //Do nothing, only occurs when there is no toast present
        });

        const toast = await t.toastCtrl.create({
          message: errorMsg,
          duration: 3000,
          showCloseButton: true,
          position: "bottom",
          color: "warning",
        });

        loader.dismiss();
        toast.present();
      });
  }

  async logout() {
    const alert = await this.alertCtrl.create({
      header: "Sign out",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          text: "Confirm",
          handler: async () => {
            let loader = await this.loadingCtrl.create({
              message: "Logging out...",
            });

            loader.present();

            this.accountService.logout().then(() => {
              loader.dismiss();
              this.navCtrl.navigateRoot("/");
              this.menuCtrl.enable(false);
            });
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
      ],
    });

    alert.present();
  }

  goToAllPosts() {
    this.navCtrl.navigateBack("/tabs/tab1");

  }




  goToCompanySettings() {
    this.navCtrl.navigateForward("/tabs/tab4/company");
  }

  async goToChangePassword() {
    this.navCtrl.navigateForward("/tabs/tab4/password");
  }

  //Recursively mark all controls of a form as untouched.
  private markFormGroupUnTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsUntouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  //Recursively mark all controls of a form as touched.
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  setDynamicValidators() {
    const matchingReceptionEmailControl = this.profileForm.get(
      "matchingReceptionEmail"
    );

    const otherMatchingReceptionEmailControl = this.profileForm.get(
      "otherMatchingReceptionEmail"
    );

    this.profileForm
      .get("useMatchingReceptionEmail")
      .valueChanges.subscribe((useMatchingReceptionEmail) => {
        if (useMatchingReceptionEmail) {
          matchingReceptionEmailControl.setValidators([Validators.required]);
        } else {
          matchingReceptionEmailControl.setValidators([]);
          otherMatchingReceptionEmailControl.setValidators([]);
        }
        matchingReceptionEmailControl.updateValueAndValidity();
        otherMatchingReceptionEmailControl.updateValueAndValidity();
      });
  }
}
